import { getNotificationDoc } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const useNotificationById = (notificationId: string | null) => {
  const { data: notification, isLoading: notificationLoading } = useSWRImmutable(notificationId, getNotificationDoc);

  return {
    notification,
    notificationLoading,
  };
};

export default useNotificationById;
